// 客户端语言检测插件
export default defineNuxtPlugin(() => {
  // 只在客户端执行
  if (process.server) return
  
  const { $i18n } = useNuxtApp()
  
  // 支持的语言列表
  const supportedLocales = ['zh-CN', 'zh-TW', 'vi_VN', 'en', 'ja_JP']
  
  // 浏览器语言到项目语言的映射
  const browserLanguageMap = {
    'zh': 'zh-CN',
    'zh-CN': 'zh-CN',
    'zh-TW': 'zh-TW',
    'zh-HK': 'zh-TW',
    'vi': 'vi_VN',
    'vi-VN': 'vi_VN',
    'en': 'en',
    'en-US': 'en',
    'en-GB': 'en',
    'ja': 'ja_JP',
    'ja-JP': 'ja_JP'
  }
  
  // 检测浏览器语言
  const detectBrowserLanguage = () => {
    const browserLanguages = navigator.languages || [navigator.language]
    
    // 遍历浏览器语言列表，找到第一个支持的语言
    for (const lang of browserLanguages) {
      // 直接匹配
      if (supportedLocales.includes(lang)) {
        return lang
      }
      
      // 通过映射表匹配
      const mappedLang = browserLanguageMap[lang]
      if (mappedLang && supportedLocales.includes(mappedLang)) {
        return mappedLang
      }
      
      // 匹配语言代码（如 zh 匹配 zh-CN）
      const langCode = lang.split('-')[0]
      const mappedLangCode = browserLanguageMap[langCode]
      if (mappedLangCode && supportedLocales.includes(mappedLangCode)) {
        return mappedLangCode
      }
    }
    
    // 如果都不匹配，返回默认语言
    return 'zh-CN'
  }
  
  // 检查是否首次访问
  const isFirstVisit = () => {
    const hasLanguageSet = localStorage.getItem('i18n_current_locale')
    const hasVisited = localStorage.getItem('has_visited')
    
    return !hasLanguageSet && !hasVisited
  }
  
  // 设置首次访问标记
  const setFirstVisitFlag = () => {
    localStorage.setItem('has_visited', 'true')
  }
  
  // 自动切换语言
  const autoSwitchLanguage = () => {
    // 检查是否首次访问
    if (!isFirstVisit()) return
    
    // 检测浏览器语言
    const detectedLanguage = detectBrowserLanguage()
    
    // 如果检测到的语言与当前语言不同，则切换
    if (detectedLanguage && detectedLanguage !== $i18n.locale.value) {
      console.log(`[语言检测] 检测到浏览器语言: ${detectedLanguage}, 当前语言: ${$i18n.locale.value}, 切换到: ${detectedLanguage}`)
      
      // 切换语言
      $i18n.setLocale(detectedLanguage)
      
      // 设置首次访问标记
      setFirstVisitFlag()
    }
  }
  
  // 在下一个tick执行，确保i18n已经初始化
  nextTick(() => {
    autoSwitchLanguage()
  })
})
